<template>
  <div>
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('components.AddMachine.9398861-0')"
      :visible.sync="visible"
      :close-on-click-modal="false"
      top="8vh"
      width="780px"
      @open="handleOpen"
      @close="handleClose"
    >
      <div :element-loading-text="$t('common.request')">
        <div class="el-search" style="border-radius: 0">
          <div style="display: flex; justify-content: flex-end">
            <el-form :model="searchForm" :inline="true" size="small" class="demo-form-inline">
              <el-form-item prop="equipmentNo" style="margin-bottom: 0; width: 140px; margin-right: 10px">
                <el-input
                  v-model="searchForm.equipmentNo"
                  :placeholder="$t('components.AddMachine.9398861-1')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="equipmentName" style="margin-bottom: 0; width: 140px; margin-right: 10px">
                <el-input
                  v-model="searchForm.equipmentName"
                  :placeholder="$t('components.AddMachine.9398861-2')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="teamName" style="margin-bottom: 0; width: 160px; margin-right: 10px">
                <el-input v-model="searchForm.teamName" :placeholder="$t('components.AddMachine.9398861-3')"></el-input>
              </el-form-item>
              <el-form-item style="margin-bottom: 0; margin-right: 0">
                <el-button type="primary" @click="handleSearch" icon="el-icon-search">{{
                  $t("components.AddMachine.9398861-4")
                }}</el-button>
                <el-button @click="handleReset" icon="el-icon-refresh">{{
                  $t("components.AddMachine.9398861-5")
                }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 列表 -->
        <el-table v-loading="loading" :data="machineList" border style="width: 100%">
          <el-table-column
            prop="equipmentNo"
            :label="$t('components.AddMachine.9398861-1')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="equipmentName"
            :label="$t('components.AddMachine.9398861-2')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="teamName"
            :label="$t('components.AddMachine.9398861-6')"
            align="center"
          ></el-table-column>
          <el-table-column fixed="right" :label="$t('components.AddMachine.9398861-7')" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="!scope.row.isselect"
                type="primary"
                icon="el-icon-check"
                size="mini"
                @click="handleBindMachine(1, scope.row.id, scope.$index)"
                style="padding: 7px"
                >{{ $t("components.AddMachine.9398861-8") }}</el-button
              >
              <el-button
                v-else
                type="danger"
                icon="el-icon-close"
                size="mini"
                @click="handleBindMachine(0, scope.row.id, scope.$index)"
                style="padding: 7px"
                >{{ $t("components.AddMachine.9398861-9") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="display: flow-root; margin-top: 20px">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page.sync="page.pageIndex"
            :total="page.totalSize"
            :page-size="page.pageSize"
            @current-change="handlePageChange"
            style="margin-top: 0"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "AddMachine",
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      surveyId: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        loading: false,
        fullscreenLoading: false,
        payActive: 3,
        qrCode: "",
        hrefurl: "",
        payOrderNo: "",
        payConfig: {},
        searchForm: {
          equipmentNo: "",
          equipmentName: "",
          teamName: ""
        },
        machineList: [],
        page: {
          pageIndex: 1,
          pageSize: 10,
          totalSize: 0
        },
        selectedMachines: [] // 存储已选择的设备ID
      };
    },

    methods: {
      handleOpen() {
        this.page.pageIndex = 1;
        this.getMachineList();
      },
      // 获取设备列表
      getMachineList() {
        this.loading = true;

        // 构建请求参数
        const params = {
          ...this.searchForm,
          pageIndex: this.page.pageIndex,
          pageSize: this.page.pageSize
          //   surveyId: this.surveyId // 添加问卷ID，用于后端判断设备是否已绑定
        };

        // 发起请求
        this.$api
          .request(this.$url.Survey.equipmentList, this.$method.get, params)
          .then(res => {
            this.loading = false;
            if (res.code === 0 && res.data) {
              const data = res.data.records || [];
              // 设置设备选中状态
              data.forEach(item => {
                item.isselect = this.selectedMachines.includes(item.id) ? 1 : 0;
              });
              this.machineList = data;
              this.page.totalSize = parseInt(res.data.total || 0);
              console.log(res.data.current, 2);
            } else {
              this.$message.error(res.msg || this.$t("components.AddMachine.9398861-10"));
              this.machineList = [];
            }
          })
          .catch(error => {
            console.error(this.$t("components.AddMachine.9398861-10"), error);
            this.$message.error(this.$t("components.AddMachine.9398861-10"));
            this.loading = false;
            this.machineList = [];
          });
      },
      // 处理页码变化
      handlePageChange(pageIndex) {
        this.page.pageIndex = pageIndex;
        this.getMachineList();
      },

      // 搜索设备
      handleSearch() {
        this.page.pageIndex = 1;
        this.getMachineList();
      },

      // 重置搜索条件
      handleReset() {
        this.searchForm = {
          equipmentNo: "",
          equipmentName: "",
          teamName: ""
        };
        this.page.pageIndex = 1;
        this.getMachineList();
      },

      // 选择/取消选择设备
      async handleBindMachine(isSelect, machineId, index) {
        // 显示加载状态
        this.loading = true;

        // 构建请求参数
        const params = {
          id: this.surveyId,
          ids: [machineId],
          type: isSelect // 1: 选择，0: 取消
        };

        try {
          // 发起请求
          const res = await this.$api.request(this.$url.Survey.configmachine, this.$method.post, params);

          // 请求成功，更新UI状态
          if (res.code === 0) {
            // 更新列表中的选中状态
            this.$set(this.machineList[index], "isselect", isSelect);

            // 更新已选择的设备列表
            if (isSelect === 1) {
              if (!this.selectedMachines.includes(machineId)) {
                this.selectedMachines.push(machineId);
              }
            } else {
              const idx = this.selectedMachines.findIndex(id => id === machineId);
              if (idx !== -1) {
                this.selectedMachines.splice(idx, 1);
              }
            }
          } else {
            // 请求失败，显示错误信息
            this.$message.error(
              res.msg ||
                (isSelect === 1
                  ? this.$t("components.AddMachine.9398861-11")
                  : this.$t("components.AddMachine.9398861-12"))
            );
          }
        } catch (error) {
          console.error(this.$t("components.AddMachine.9398861-13"), error);
          this.$message.error(
            isSelect === 1 ? this.$t("components.AddMachine.9398861-11") : this.$t("components.AddMachine.9398861-12")
          );
        } finally {
          this.loading = false;
        }
      },

      // 关闭对话框
      handleClose() {
        this.dialogVisible = false;
        this.$emit("close");
      },

      // 确认添加设备
      handleConfirm() {
        if (this.selectedMachines.length === 0) {
          this.$message.warning(this.$t("components.AddMachine.9398861-14"));
          return;
        }

        this.loading = true;
        // 构建请求参数
        const params = {
          surveyId: this.surveyId,
          machineIds: this.selectedMachines
        };

        // 发起请求
        this.$api
          .request(this.$url.Survey.bindmachine, this.$method.post, params)
          .then(res => {
            this.loading = false;
            if (res.code === 0) {
              this.$message.success(this.$t("components.AddMachine.9398861-15"));
              this.handleClose();
              this.$emit("success");
            } else {
              this.$message.error(res.msg || this.$t("components.AddMachine.9398861-16"));
            }
          })
          .catch(error => {
            console.error(this.$t("components.AddMachine.9398861-16"), error);
            this.$message.error(this.$t("components.AddMachine.9398861-16"));
            this.loading = false;
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .el-search {
    padding: 10px;
    margin-bottom: 15px;
    border-radius: 4px;
    background-color: #f5f7fa;
  }
</style>
